const warningMessageTypes = {
    SERVICE_CASE_IN_EDITING: 'SERVICE_CASE_IN_EDITING',
    INVOICE_IN_EDITING: 'INVOICE_IN_EDITING',
};

export default warningMessageTypes;
